import { Dispatch, SetStateAction, useState } from "react";
import "./AboutUs.css";
import { useDarkMode } from "../../Services/Context/DarkModeContext";

const AboutUs = ({
  setIsAboutUsOpen,
}: {
  setIsAboutUsOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const [isAboutUsClosing, setIsAboutUsClosing] = useState(false);
  const { dark } = useDarkMode();

  return (
    <div
      className={`About-us-container ${
        isAboutUsClosing
          ? "animate__animated animate__fadeOutDownBig"
          : "animate__animated animate__fadeInUpBig"
      }`}
      style={{ background: dark ? "#050505ff" : "#ffffff" }}
    >
      <div className="About-us">
        <div>
          Welcome!
          <br />
          <br />
          <span className="bold">Upcoming Features</span>
          <br />
          This site is evolving as I explore new creative and spiritual ideas.
          Here’s a glimpse at what’s possibly to come:
          <ul>
            <li>
              Different Card Spreads – Choose from classic layouts like the
              Three-Card Spread, Celtic Cross, and more to deepen your readings.
            </li>

            <li>
              Interactive Readings – Experience dynamic, AI-guided themed tarot
              sessions that adapt to your energy and choices.
            </li>

            <li>Background Music for better atmosphere </li>

            <li>
              Different Deck Art options, as well as a Custom Deck upload option
            </li>

            <li>Log in feature to save settings</li>
          </ul>
        </div>
        <br />
        <div>
          <span className="bold">Feedback</span>
          <br />
          If you spot a bug, have an insight, or just want to share feedback,
          feel free to reach out — I’m always open to improving and learning
          from the community. You can message me directly through email at
          fatespintarot@gmail.com or{" "}
          <a href="https://discord.com/channels/1424950467078914060/1424950468668424255">
            join our discord.
          </a>
        </div>
        <br />
        <div>
          <span className="bold">Credits</span>
          <br />
          Icons and assets featured on this site are used under their respective
          licenses from Flaticon. A huge thanks to these talented creators for
          providing high-quality, open-source resources that help designers and
          developers express ideas visually.
          <br />
          <ul>
            <li>
              <a
                href="https://www.flaticon.com/free-icons/tarot"
                title="tarot icons"
              >
                Tarot icons created by Imogen.Oh - Flaticon
              </a>
            </li>
            <li>
              <a
                href="https://www.flaticon.com/free-icons/plus"
                title="plus icons"
              >
                Plus icons created by FlexSolution - Flaticon
              </a>
            </li>
          </ul>
        </div>
        <br />
        <button
          className="AboutUs-close"
          onClick={() => {
            setIsAboutUsClosing(true);
            setTimeout(() => {
              setIsAboutUsOpen(false);
            }, 700);
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default AboutUs;
